<template>
  <div class="dashboard-skeleton" aria-hidden="true">
    <section v-if="showQuick" class="dashboard-skeleton__section">
      <div class="dashboard-skeleton__header">
        <span
          class="dashboard-skeleton__line dashboard-skeleton__line--title"
        ></span>
        <span class="dashboard-skeleton__button"></span>
      </div>
      <div class="dashboard-skeleton__quick-grid">
        <div
          v-for="item in quickMenuCount"
          :key="`quick-${item}`"
          class="dashboard-skeleton__quick-card"
        >
          <span class="dashboard-skeleton__icon"></span>
          <span
            class="dashboard-skeleton__line dashboard-skeleton__line--label"
          ></span>
        </div>
      </div>
    </section>

    <section v-if="showRecent" class="dashboard-skeleton__section">
      <div class="dashboard-skeleton__header">
        <span
          class="dashboard-skeleton__line dashboard-skeleton__line--title"
        ></span>
        <span class="dashboard-skeleton__button"></span>
      </div>
      <div class="dashboard-skeleton__recent-grid">
        <div
          v-for="item in recentContentCount"
          :key="`recent-${item}`"
          class="dashboard-skeleton__recent-card"
        >
          <span class="dashboard-skeleton__image"></span>
          <span
            class="dashboard-skeleton__line dashboard-skeleton__line--category"
          ></span>
          <span
            class="dashboard-skeleton__line dashboard-skeleton__line--content-title"
          ></span>
          <div class="dashboard-skeleton__actions">
            <span class="dashboard-skeleton__action"></span>
            <span class="dashboard-skeleton__action"></span>
          </div>
          <div class="dashboard-skeleton__footer">
            <span
              class="dashboard-skeleton__line dashboard-skeleton__line--date"
            ></span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DashboardSkeleton",
  props: {
    showQuick: {
      type: Boolean,
      default: true,
    },
    showRecent: {
      type: Boolean,
      default: true,
    },
    quickMenuCount: {
      type: Number,
      default: 8,
    },
    recentContentCount: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style scoped>
.dashboard-skeleton {
  color: transparent;
  width: 100%;
}

.dashboard-skeleton__section {
  margin-bottom: 24px;
}

.dashboard-skeleton__header {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dashboard-skeleton__line,
.dashboard-skeleton__button,
.dashboard-skeleton__icon,
.dashboard-skeleton__image {
  animation: dashboard-skeleton-pulse 1.4s ease-in-out infinite;
  background: #e5e7eb;
  display: block;
}

.dashboard-skeleton__line {
  border-radius: 6px;
  height: 16px;
}

.dashboard-skeleton__line--title {
  height: 24px;
  width: 180px;
}

.dashboard-skeleton__button {
  border-radius: 10px;
  height: 48px;
  width: 132px;
}

.dashboard-skeleton__quick-grid,
.dashboard-skeleton__recent-grid {
  display: grid;
  gap: 16px;
}

.dashboard-skeleton__quick-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-skeleton__quick-card,
.dashboard-skeleton__recent-card {
  background: #fff;
  border: 1px solid #edf0f3;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.dashboard-skeleton__quick-card {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  min-height: 112px;
  padding: 16px 12px;
}

.dashboard-skeleton__icon {
  border-radius: 50%;
  height: 28px;
  width: 28px;
}

.dashboard-skeleton__line--label {
  width: min(80%, 110px);
}

.dashboard-skeleton__recent-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.dashboard-skeleton__recent-card {
  min-width: 0;
  overflow: hidden;
  padding-bottom: 16px;
}

.dashboard-skeleton__image {
  border-radius: 0;
  height: 176px;
  margin-bottom: 16px;
  width: 100%;
}

.dashboard-skeleton__line--category,
.dashboard-skeleton__line--content-title {
  margin: 0 16px 10px;
}

.dashboard-skeleton__line--category {
  width: 40%;
}

.dashboard-skeleton__line--content-title {
  height: 20px;
  width: 72%;
}

.dashboard-skeleton__actions {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: auto 16px 16px;
  padding-top: 8px;
}

.dashboard-skeleton__action {
  animation: dashboard-skeleton-pulse 1.4s ease-in-out infinite;
  background: #e5e7eb;
  border-radius: 10px;
  display: block;
  height: 48px;
}

.dashboard-skeleton__footer {
  border-top: 1px solid #edf0f3;
  min-height: 48px;
  padding: 12px 16px;
}

.dashboard-skeleton__line--date {
  height: 12px;
  margin: 6px 0 0;
  width: 48%;
}

@keyframes dashboard-skeleton-pulse {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}

@media (min-width: 640px) {
  .dashboard-skeleton__quick-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .dashboard-skeleton__recent-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 960px) {
  .dashboard-skeleton__quick-grid,
  .dashboard-skeleton__recent-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  .dashboard-skeleton__header {
    align-items: stretch;
    flex-direction: column;
  }

  .dashboard-skeleton__button {
    width: 100%;
  }

  .dashboard-skeleton__quick-grid {
    gap: 12px;
  }

  .dashboard-skeleton__recent-grid {
    gap: 16px;
    grid-template-columns: minmax(0, 1fr);
  }

  .dashboard-skeleton__quick-card {
    min-height: 92px;
    padding: 12px 8px;
  }

  .dashboard-skeleton__image {
    height: 128px;
  }

  .dashboard-skeleton__line--category,
  .dashboard-skeleton__line--content-title {
    margin-left: 12px;
    margin-right: 12px;
  }

  .dashboard-skeleton__actions {
    grid-template-columns: minmax(0, 1fr);
    margin-left: 12px;
    margin-right: 12px;
  }

  .dashboard-skeleton__footer {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media (max-width: 359px) {
  .dashboard-skeleton__quick-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dashboard-skeleton__line,
  .dashboard-skeleton__button,
  .dashboard-skeleton__icon,
  .dashboard-skeleton__image,
  .dashboard-skeleton__action {
    animation: none;
  }
}
</style>
